/* Termos comuns utilizados em todo o sistema */
export const CommonTranslations = {
  // botões padrões
  BUTTON_CANCEL: 'btn_cancel',
  BUTTON_DELETE: 'btn_del',
  BUTTON_NEW: 'btn_new',
  BUTTON_SAVE: 'btn_save',

  // checkboxes padrões
  CHECKBOX_ATIVO: 'chk_ativo',
  CHECKBOX_INATIVO: 'chk_inativo',

  // colunas de grids
  GRID_COLUMN_ACOES: 'grid_column_acoes',

  // itens das abas gerais
  TABSHEET_GERAL: 'tabsheet_geral',

  // labels padrões
  LABEL_PASSWORD: 'lbl_pwd',
  LABEL_PDV: 'lbl_pdv',
  LABEL_USER: 'lbl_user',

  // menus gerais
  MENU_CADASTRO: 'menu_cad',
  MENU_DASHBOARD: 'menu_dash',
  MENU_PROCEDIMENTOS: 'menu_proced',
  MENU_SAIR: 'menu_sair',

  // itens de menus gerais
  MENU_ITEM_CLIENTE: 'menu_item_cli',
  MENU_ITEM_FERIADO: 'menu_item_feriado',
  MENU_ITEM_PAIS: 'menu_item_pais',
  MENU_ITEM_USUARIO: 'menu_item_user',

  // menus do módulo Adm AppCli
  MENU_PASSENGER: 'menu_passenger',

  // itens de menu do módulo Adm AppCli
  MENU_ITEM_ANALYTICS: 'menu_item_analytics',
  MENU_ITEM_PASSAGEIRO: 'menu_item_pax',

  // menus do módulo Adm Partner
  MENU_AGENDA_ESCALA: 'menu_agenda_esc',
  MENU_USUARIO_PARTNER: 'menu_user_partner',

  // menus do módulo CRM
  MENU_WHATSAPP: 'menu_wpp',

  // itens de menu do módulo CRM
  MENU_ITEM_WHATSAPP_CHAT: 'menu_item_wpp_chat',
  MENU_ITEM_WHATSAPP_ENVIO: 'menu_item_wpp_envio',
  MENU_ITEM_WHATSAPP_GRUPO_MENSAGEM: 'menu_item_wpp_grp_msg',
  MENU_ITEM_WHATSAPP_MENSAGEM: 'menu_item_wpp_msg',

  // menus do módulo Finanças
  MENU_FECHAMENTO_FINANCEIRO: 'menu_fch_financ',

  // itens de menu do módulo Finanças
  MENU_ITEM_BANCO: 'menu_item_bco',
  MENU_ITEM_CONTA_CORRENTE: 'menu_item_cc',
  MENU_ITEM_EXECUTAR_FECHAMENTO: 'menu_item_exec_fch',
  MENU_ITEM_HISTORICO_BANCARIO: 'menu_item_hist_banc',
  MENU_ITEM_HISTORICO_FECHAMENTO: 'menu_item_hist_fch',
  MENU_ITEM_SETOR: 'menu_item_st',
  MENU_ITEM_TIPO_DOCUMENTO: 'menu_item_tipo_doc',
  MENU_ITEM_TRANSACAO: 'menu_item_txn',

  // itens de menu do módulo Front
  MENU_ITEM_CATEGORIA_SERVICO_FRONT: 'menu_item_categ_serv_front',
  MENU_ITEM_MOTIVO_CANCELAMENTO: 'menu_item_mtv_canc',
  MENU_ITEM_ORDEM_SERVICO_FRONT: 'menu_item_os_front',
  MENU_ITEM_SERVICO_FRONT: 'menu_item_serv_front',
  MENU_ITEM_TIPO_VEICULO_FRONT: 'menu_item_tipo_veic_front',
  MENU_ITEM_VEICULO_FRONT: 'menu_item_veic_front',
  MENU_ITEM_VENDEDOR: 'menu_item_vend',

  // itens de menu do módulo Frotas
  MENU_ITEM_ABASTECIMENTO: 'menu_item_abast',
  MENU_ITEM_ABASTECIMENTO_LANCAR: 'menu_item_abast_lcto',
  MENU_ITEM_MARCA_VEICULO: 'menu_item_marca_veic',
  MENU_ITEM_MODELO_VEICULO: 'menu_item_model_veic',
  MENU_ITEM_OPCIONAL_VEICULO: 'menu_item_opc_veic',
  MENU_ITEM_ORDEM_SERVICO_MANUTENCAO: 'menu_item_os_manut',
  MENU_ITEM_TIPO_VEICULO_FROTAS: 'menu_item_tipo_veic_frotas',
  MENU_ITEM_VEICULO_FROTAS: 'menu_item_veic_frotas',

  // menus do módulo Gerencial
  MENU_ADMINISTRATIVO: 'menu_admin',
  MENU_FINANCEIRO: 'menu_financ',
  MENU_OPERACIONAL: 'menu_operac',
  MENU_PRODUCAO: 'menu_prod'
};

/* Chaves de tradução dos labels do dashboard do módulo Front */
export const Dashboard_Translations = {
  LABEL_CHEGADAS: 'lbl_dash_chegadas',
  LABEL_PARTIDAS: 'lbl_dash_partidas',
  LABEL_PAX_DESTINO: 'lbl_dash_pax_destino'
};

/* Chaves de tradução do formulário de OS */
export const Form_OS_Translations = {
  FORM_ORDEM_SERVICO_TITLE: 'form_OS_title'
};

/* Chaves de tradução do formulário de categoria de serviço */
export const Form_Categoria_Servico_Translations = {
  FORM_CATEGORIA_SERVICO_TITLE: 'form_categ_serv_title'
};

/* Chaves de tradução da listagem de categoria de serviço */
export const list_Categoria_Servico_Translations = {
  LIST_CATEGORIA_SERVICO_TITLE: 'list_categ_serv_grid_column'
};